import 'babel-polyfill';
import Swiper from 'swiper';

$(document).ready(function () {

    const swiper = new Swiper('.swiper-container', {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false,
        },
        speed: 3000,
        on: {
            init: function() {
                this.$el.removeClass('invisible');
            }
        }
    });

});